/**
 * XHM 門店三軌槽位（Overseas patch 260）
 */
export const XHM_FAMILY_SLOT_MENU_IDS = {
  group: 990468,
  desk: 990469,
  view: 990470,
  gate: 990471
}

export default XHM_FAMILY_SLOT_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/xhmFamilySlot.js